import styled from 'styled-components'
import { useModalShow } from '~/lib/hooks/modal'
import ManageIsAdultModal from './ManageIsAdultModal'

interface Props {
  children: React.ReactNode
}

export default function ManageIsAdultModalManager({ children }: Props) {
  const [show, handleOpenModal, handleCloseModal] = useModalShow()

  return (
    <>
      <ChildWrapper onClick={handleOpenModal}>{children}</ChildWrapper>
      <ManageIsAdultModal show={show} onClose={handleCloseModal} />
    </>
  )
}

const ChildWrapper = styled.div``
